const productCardFactory = require('../shelfproduct/shelfbundle-card-factory');
const stringHelpers = require('../../../common/components/stringhelpers');
const atmProductListMapper = require('./atm/product-list-mapper');

module.exports = function (CacheService, $location, searchService, $state, settingsService, catalogService, decorateAdditionalDetails, categoriesService, RRPubSub, pageMetadataService, $window, $timeout, filtersService, atm) {
    return {
        restrict: 'E',
        require: '^wowCardList',
        scope: {},
        link(scope, element, attrs, cardListCtrl) {
            categoriesService.categories = [];

            function getCurrentUrl() {
                const pageNumberPattern = /pageNumber\=(\d+)/gi;
                const url = pageNumberPattern.test($location.$$absUrl)
                                ? $location.$$absUrl
                                : $location.$$absUrl + '?pageNumber=1';

                return url;
            }

            function getCatalog(response, pageNumber) {
                //async needed
                $timeout(null, 0).then(() => {
                    const currentUrl = getCurrentUrl();
                    const cached = CacheService.get(currentUrl);

                    const category = catalogService.flatternCategoriesAttributes(response);
                    categoriesService.categories = category;
                    if (cached != null) {
                        cached.categories = category;
                        CacheService.set(currentUrl, cached);
                    }

                    cardListCtrl.updateTitle();

                    const categorymetakeyword = categoriesService.categories[0].Attributes.categorymetakeyword || '';
                    let categorydescription = categoriesService.categories[0].Attributes.category_description || '';
                    if (categorydescription) {
                        const catDescMatch = categorydescription.match(/<a [^>]+>([^<]+)<\/a>/);
                        //Get the text in anchor tag and replace the full anchor tag with the text in anchor tag
                        categorydescription = catDescMatch ? categorydescription.replace(catDescMatch[0], catDescMatch[1]) : categorydescription;
                    }
                    let metaTitle = filtersService.seoTags ? filtersService.seoTags.Title : `Buy ${categoriesService.categories[0].Name} ${categorymetakeyword} Online | BWS`;
                    //This is to fall back on existing changes if api is not deployed
                    if (metaTitle === ' | BWS') {
                        metaTitle = `Buy ${categoriesService.categories[0].Name} ${categorymetakeyword} Online | BWS`;
                    }
                    let metaDescriptionCustom = filtersService.seoTags ? ((categorydescription) ? categorydescription : filtersService.seoTags.MetaDescription) : `Explore the wide selection of ${categoriesService.categories[0].Name} ${categorymetakeyword} available online at BWS, your local bottle shop. Order online today`;
                    //This is to fall back on existing changes if api is not deployed
                    if (metaDescriptionCustom === `Shop for today's special at BWS.With over 1200 stores across Australia, you'll always find a way to celebrate with our wide range of Beer, Wine and Spirits.`) {
                        metaDescriptionCustom = `Explore the wide selection of ${categoriesService.categories[0].Name} ${categorymetakeyword} available online at BWS, your local bottle shop. Order online today`;
                    }
                    pageMetadataService.setMetadata({
                        title: metaTitle,
                        metaDescription: metaDescriptionCustom
                    }, true);

                });

                if (pageNumber === 1) {
                    let leafCategory = $state.params.subcategory || $state.params.category || $state.params.subdepartment || $state.params.department || undefined;
                    leafCategory = leafCategory ? stringHelpers.toTitleCase(leafCategory.replace(new RegExp('-', 'g'), ' ')) : undefined;
                    RRPubSub.publish(RRPubSub.EVENTS.CATEGORY_PAGE, {
                        id: response.categoryId,
                        name: leafCategory,
                        items: response.items
                    });
                }

            }

            function createCards(result, pageNumber) {

                if (result.totalRecordCount === 0 && !$state.params.filters) {
                    cardListCtrl.updateZeroCardTemplate(null);
                    return {
                        items: [],
                        totalRecordCount: result.totalRecordCount
                    };
                }

                getCatalog(result, pageNumber);

                for (let i = 0; i < result.items.length; i++) {
                    decorateAdditionalDetails(result.items[i].Products);
                }

                // the result items order preference and relevancies are being changed in the transformProductsToDefault
                // so the same reference should be used in createProductCards
                const resultItems = result.items;
                const defaultProducts = searchService.transformProductsToDefault(resultItems, null, result.ads);

                return {
                    items: productCardFactory.createProductCards(defaultProducts, resultItems),
                    totalRecordCount: result.totalRecordCount,
                    productCollection: resultItems,
                    featureTiles: result.featureTiles
                };
            }

            function updateProductListAnalytics(categoryID) {
                const pidList = categoriesService.getPidList(categoryID);
                atm.push({ pidList }, atmProductListMapper);
            }

            // Product provider function
            function getCards(pageSize, pageNumber, isSpecial, filters, banner) {

                return settingsService.getSettingValue('Browse', 'SortOptions')
                    .then(function (response) {
                        return response[0].Value;
                    }).then(function (sortBySetting) {

                        const { department, subdepartment, category, subcategory, sortby } = $state.params;

                        const categoryRequestData = {
                            department,
                            category,
                            filters,
                            banner,
                            isSpecial,
                            pageSize,
                            pageNumber,
                            subDepartment: subdepartment,
                            subCategory: subcategory,
                            Location: $window.location.pathname,
                            sortType: sortby || sortBySetting
                        };

                        return searchService.searchByCategory(categoryRequestData)
                                            .then((response) => {
                                                if (response) {
                                                    const categoryID = response.Categories && response.Categories[0] && response.Categories[0].Id;
                                                    const resultPidList = response.items.map(item => item.PackDefaultStockCode);
                                                    catalogService.catalog.categories = [];
                                                    catalogService.selectedCategory = categoryRequestData;
                                                    categoriesService.setPidList(categoryID, resultPidList);
                                                    updateProductListAnalytics(categoryID);
                                                    return createCards(response, pageNumber);
                                                }
                                                return;
                                            });
                    });
            }

            function getTitle() {
                return (categoriesService.categories && categoriesService.categories.length > 0)
                        ? categoriesService.categories[0].Name
                        : '';
            }

            cardListCtrl.setOptions({
                getCards,
                getTitle,
                zeroCardsTemplate: '<wow-search-zero-results></wow-search-zero-results>',
                updateCardsOnLogin: true
            });

            cardListCtrl.update();
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/categories/product-list-directive.js
 **/